import { useLocation } from 'react-router-dom';

export const useLocationState = () => {
  const location = useLocation();

  const removeDeployPath = (path: string | undefined) => {
    const deployPath = process.env.REACT_APP_PREVIEW_DEPLOY_PATH;

    if (path && deployPath) {
      return path.replace(deployPath, '');
    }

    return path;
  };

  const locationFrom = () => {
    return removeDeployPath(location?.state?.from);
  };

  const locationPathname = () => {
    return removeDeployPath(location?.state?.pathname);
  };

  return { locationFrom, locationPathname };
};
